import { useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { getCoreRowModel } from '@tanstack/react-table';

// MUI Theme
import Paper from '@mui/material/Paper';

// Utils
import { Storage } from '../../../utils/Storage';
import { makeCollectionDetailColumn } from '../../../utils/columns/makeCollectionDetailColumn';

// Services
import { getCollectionDetails } from '../../../services/collections.service';

// Types
import { SearchBarFilterTypes } from '../../../constants/Constants';

// Commmon
import SearchBar from '../../common/SearchBar/SearchBar';
import { useStandardTable as useTable, Table } from '../../common/table/index';

// Components
import CollectionStage from './CollectionStage';

const CollectionDetails = () => {
  const { id } = useParams();
  const [paramFilter, setParamFilter] = useState<any>({
    collectionId: id,
  });
  const location = useLocation();
  const collectionDetails = location.state;

  const handleReset = () => {
    setParamFilter({ collectionId: id, filters: [], sortBy: paramFilter.sortBy });
    Storage.setSearchBarFiltering(SearchBarFilterTypes.COLLECTIONS, { filters: [] });
  };

  const columns = useMemo(makeCollectionDetailColumn, []);

  const table = useTable<any>({
    columns,
    fetchAsync: getCollectionDetails,
    params: paramFilter,
    serverSide: true,
    shouldFetch: true,
  });

  const onSearchChange = (filters: any) => {
    setParamFilter({ collectionId: id, filters: filters });
    Storage.setSearchBarFiltering(SearchBarFilterTypes.COLLECTIONS, { isMoreFilter: true, filters: filters });
  };

  return (
    <>
      {collectionDetails && <CollectionStage details={collectionDetails} />}
      <SearchBar pageKey={SearchBarFilterTypes.COLLECTIONS} onSearch={onSearchChange} onReset={handleReset} columns={columns} allowSearchAll={true} />
      <Paper>
        <Table {...table} showSearchBar={false} showColumnToggler={false} getCoreRowModel={getCoreRowModel()} />
      </Paper>
    </>
  );
};

export default CollectionDetails;
